import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZDeviceDetailsData = z.object({
  deviceTemplateId: z.string(),
  deviceType: z.string(),
  commTypeId: z.string(),
  commType: z.string(),
  fileName: z.string(),
  uploadStatus: z.string(),
  registers: z.any()
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: ZDeviceDetailsData
})

export type DeviceDetailsById = z.infer<typeof ZApiResponse>
export type DeviceDetailsByIdDetails = z.infer<typeof ZDeviceDetailsData>

export async function getDeviceDetailsById (
  deviceId: string,
  onSuccess: (customDeviceListByID: DeviceDetailsByIdDetails, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/${deviceId}`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      onFailure(error.message, error.status)
    })
}
